<template>
  <a-card :bordered="false">

    <div class="table-page-search-wrapper">
      <a-row>
        <a-col :md="2" :sm="24">
          <a-button style="margin-bottom: 10px" type="primary" @click="handleConfigAdd">Add Configuration</a-button>
        </a-col>
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        bordered
      >
        <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">Edit</a>
            </span>

      </a-table>
    </div>
    <riskRuleAddModal ref="riskRuleAddModal" @ok="modalFormOk"></riskRuleAddModal>
    <riskRuleEditModal ref="riskRuleEditModal" @ok="modalFormOk"></riskRuleEditModal>

  </a-card>
</template>

<script>

import Dict from '../modules/Dict'
import {riskStrategyFeatures} from '@/webpublicapi/risk'
import riskRuleAddModal from './riskRuleAdd'
import riskRuleEditModal from './riskRuleEdit'

export default {
  name: 'productItemList',
  components: {Dict, riskRuleAddModal, riskRuleEditModal},
  props: {
    id: {
      type: [String, Number],
      default: undefined,
    }
  },
  data() {
    return {
      dataSource: [],
      loading: false,
      columns: [
        {
          title: 'StrategyID',
          align: 'center',
          dataIndex: 'id'
        },
        {
          title: 'Strategy Set ID',
          align: 'center',
          dataIndex: 'strategyId'
        },
        {
          title: 'Feature ID',
          align: 'center',
          dataIndex: 'featuresId'
        },
        {
          title: 'YesNoUse',
          align: 'center',
          dataIndex: 'isDel'
        },
        {
          title: 'Execution Sequence',
          align: 'center',
          dataIndex: 'sortNum'
        },
        {
          title: 'Intersection',
          align: 'center',
          dataIndex: 'andGroup'
        },
        {
          title: 'Calculation Rule',
          align: 'center',
          dataIndex: 'rule'
        }, {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: {customRender: 'action'}
        }
      ],
      title: 'Action',
      visible: false,
      screenWidth: 1200,
      model: {},
      proId: '',
    }
  },
  created() {
    this.proId = this.id;

    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true


      riskStrategyFeatures(Object.assign({strategyId: this.proId})).then((res) => {
        if (res.code === 1000) {
          this.dataSource = res.data
        } else {
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },


    handleEdit(record) {

      this.$refs.riskRuleEditModal.edit(record)
    },
    handleConfigAdd() {
      this.$refs.riskRuleAddModal.add(this.proId)
    },

    // Edit dictionary data
    editProdictConfig() {
      this.$refs.ProdictConfigList.edit(this.proId, this.appSsid)
      this.$refs.ProdictConfigList.title = 'AddConfiguration'
    },
    modalFormOk() {
      this.loadData()
    }
  },
  watch: {
    proId(val) {
      this.proId = val
    }
  }
}
</script>
<style scoped>

</style>
